import FileAttachmentTile from './FileAttachmentTile';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getFileMetadata } from 'conversations-internal-schema/resolved-attachment/operators/resolvedAttachmentGetters';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../theming/contexts/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const AttachmentsFooterWrapper = styled.div.withConfig({
  displayName: "AttachmentsFooter__AttachmentsFooterWrapper",
  componentId: "m6ts8y-0"
})(["cursor:pointer;box-sizing:border-box;display:block;background-color:", ";"], ({
  backgroundColor
}) => backgroundColor);
export const StyledFileAttachmentTile = styled(FileAttachmentTile).withConfig({
  displayName: "AttachmentsFooter__StyledFileAttachmentTile",
  componentId: "m6ts8y-1"
})(["background-color:", ";"], ({
  backgroundColor
}) => backgroundColor || 'rgba(255, 255, 255, 0.5)');
class AttachmentsFooter extends PureComponent {
  render() {
    const {
      fileAttachments
    } = this.props;
    const {
      fileAttachmentTheme: {
        tileBackgroundColor
      },
      backgroundColor
    } = this.context;
    return /*#__PURE__*/_jsx(AttachmentsFooterWrapper, {
      "data-test-id": "attachments-footer",
      backgroundColor: backgroundColor,
      children: fileAttachments.map((fileAttachment, index) => {
        return /*#__PURE__*/_jsx(StyledFileAttachmentTile, {
          fileMetadata: getFileMetadata(fileAttachment),
          backgroundColor: tileBackgroundColor
        }, index);
      })
    });
  }
}
AttachmentsFooter.displayName = 'AttachmentsFooter';
AttachmentsFooter.propTypes = {
  // @ts-expect-error - replace after immutable conversion
  fileAttachments: PropTypes.instanceOf(List).isRequired
};
AttachmentsFooter.contextType = ThemeContext;
export default AttachmentsFooter;